import React  from 'react';
import { useSuspense } from '@rest-hooks/react';

import OwnedProductsResource from 'resources/user/OwnedProductsResource';

import MerchGrid from 'components/CardGrids/MerchGrid';
import Layout from 'components/layouts/index';
import TabPanels from 'components/TabPanels';

import { t } from 'i18n/index';

const pageInfo = {
    name: 'My Merch',
    description: 'Merch and perks you have purchased. Present the QR code at the store to collect.',
  };

const Merch = () => {

    const upcomingMerch = useSuspense(OwnedProductsResource.list(), { upcoming: true });
    const pastMerch = useSuspense(OwnedProductsResource.list());

    const labels = [ `${t('literal:upcoming')}` ];
    pastMerch.length > 0 && labels.push(t('literal:past'));

    return (
        <Layout context='student'
                activeMenuItem="merch"
                pageInfo={ pageInfo } >

            <TabPanels labels={labels}>

                    {upcomingMerch.length > 0 ?
                        <MerchGrid data={ upcomingMerch } /> :
                        <p>No merch to collect yet.</p>
                    }

                    <MerchGrid data={ pastMerch } />

            </TabPanels>
        </Layout>
    );
};

export default Merch;
